import { getAgencyIdByIpScope } from "@/request/api";
import useLogin from "@/stores/login";

/** @type {Promise<{ ok: boolean, needSelect?: boolean, list: Array }> | null} */
let resolvePromise = null;

const IP_AGENCY_PATHS = ["/index", "/courseDetails", "/login"];

export function canResolveAgencyByPath(pathname = window.location.pathname) {
  return IP_AGENCY_PATHS.includes(pathname);
}

function applyAgency(loginStore, agency) {
  loginStore.agencyId = agency?.value;
  loginStore.code = agency?.code;
}

/**
 * 未登录时按 IP 解析机构；同一会话内复用请求，避免登录页与顶栏重复调用。
 */
export function ensureAgencyByIp(force = false) {
  const loginStore = useLogin();
  if (loginStore.isLogin) {
    return Promise.resolve({ ok: true, needSelect: false, list: [] });
  }

  if (force) {
    resolvePromise = null;
  }
  if (resolvePromise) {
    return resolvePromise;
  }

  resolvePromise = getAgencyIdByIpScope({ agencyId: loginStore.agencyId })
    .then((res) => {
      if (res.status !== 10000) {
        return { ok: false, needSelect: false, list: [] };
      }
      const list = res.data || [];
      if (list.length === 1) {
        applyAgency(loginStore, list[0]);
        return { ok: true, needSelect: false, list };
      }
      if (list.length > 1) {
        return { ok: false, needSelect: true, list };
      }
      loginStore.agencyId = undefined;
      return { ok: false, needSelect: false, list: [] };
    })
    .catch(() => ({ ok: false, needSelect: false, list: [] }));

  return resolvePromise;
}

export function resetAgencyResolve() {
  resolvePromise = null;
}
